import { commonjsGlobal as _t } from "./index.es224.js";
import te from "./index.es225.js";
var X, Et;
function ne() {
  if (Et) return X;
  Et = 1;
  var R = typeof Map == "function" && Map.prototype, T = Object.getOwnPropertyDescriptor && R ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, $ = R && T && typeof T.get == "function" ? T.get : null, Y = R && Map.prototype.forEach, L = typeof Set == "function" && Set.prototype, k = Object.getOwnPropertyDescriptor && L ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, I = L && k && typeof k.get == "function" ? k.get : null, Z = L && Set.prototype.forEach, $t = typeof WeakMap == "function" && WeakMap.prototype, d = $t ? WeakMap.prototype.has : null, It = typeof WeakSet == "function" && WeakSet.prototype, O = It ? WeakSet.prototype.has : null, Wt = typeof WeakRef == "function" && WeakRef.prototype, x = Wt ? WeakRef.prototype.deref : null, Mt = Boolean.prototype.valueOf, qt = Object.prototype.toString, Rt = Function.prototype.toString, Tt = String.prototype.match, A = String.prototype.slice, c = String.prototype.replace, Lt = String.prototype.toUpperCase, b = String.prototype.toLowerCase, j = RegExp.prototype.test, tt = Array.prototype.concat, l = Array.prototype.join, kt = Array.prototype.slice, et = Math.floor, D = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, N = Object.getOwnPropertySymbols, C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, S = typeof Symbol == "function" && typeof Symbol.iterator == "object", w = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === S || !0) ? Symbol.toStringTag : null, rt = Object.prototype.propertyIsEnumerable, nt = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
    return t.__proto__;
  } : null);
  function at(t, e) {
    if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || j.call(/e/, e))
      return e;
    var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof t == "number") {
      var a = t < 0 ? -et(-t) : et(t);
      if (a !== t) {
        var i = String(a), r = A.call(e, i.length + 1);
        return c.call(i, n, "$&_") + "." + c.call(c.call(r, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return c.call(e, n, "$&_");
  }
  var B = te, it = B.custom, ot = ct(it) ? it : null, ut = {
    __proto__: null,
    double: '"',
    single: "'"
  }, At = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  X = function t(e, n, a, i) {
    var r = n || {};
    if (f(r, "quoteStyle") && !f(ut, r.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (f(r, "maxStringLength") && (typeof r.maxStringLength == "number" ? r.maxStringLength < 0 && r.maxStringLength !== 1 / 0 : r.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var y = f(r, "customInspect") ? r.customInspect : !0;
    if (typeof y != "boolean" && y !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (f(r, "indent") && r.indent !== null && r.indent !== "	" && !(parseInt(r.indent, 10) === r.indent && r.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (f(r, "numericSeparator") && typeof r.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var v = r.numericSeparator;
    if (typeof e > "u")
      return "undefined";
    if (e === null)
      return "null";
    if (typeof e == "boolean")
      return e ? "true" : "false";
    if (typeof e == "string")
      return yt(e, r);
    if (typeof e == "number") {
      if (e === 0)
        return 1 / 0 / e > 0 ? "0" : "-0";
      var o = String(e);
      return v ? at(e, o) : o;
    }
    if (typeof e == "bigint") {
      var s = String(e) + "n";
      return v ? at(e, s) : s;
    }
    var H = typeof r.depth > "u" ? 5 : r.depth;
    if (typeof a > "u" && (a = 0), a >= H && H > 0 && typeof e == "object")
      return P(e) ? "[Array]" : "[Object]";
    var h = xt(r, a);
    if (typeof i > "u")
      i = [];
    else if (pt(i, e) >= 0)
      return "[Circular]";
    function u(m, q, jt) {
      if (q && (i = kt.call(i), i.push(q)), jt) {
        var wt = {
          depth: r.depth
        };
        return f(r, "quoteStyle") && (wt.quoteStyle = r.quoteStyle), t(m, wt, a + 1, i);
      }
      return t(m, r, a + 1, i);
    }
    if (typeof e == "function" && !ft(e)) {
      var gt = Vt(e), vt = W(e, u);
      return "[Function" + (gt ? ": " + gt : " (anonymous)") + "]" + (vt.length > 0 ? " { " + l.call(vt, ", ") + " }" : "");
    }
    if (ct(e)) {
      var St = S ? c.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : C.call(e);
      return typeof e == "object" && !S ? _(St) : St;
    }
    if (Xt(e)) {
      for (var E = "<" + b.call(String(e.nodeName)), V = e.attributes || [], M = 0; M < V.length; M++)
        E += " " + V[M].name + "=" + lt(Dt(V[M].value), "double", r);
      return E += ">", e.childNodes && e.childNodes.length && (E += "..."), E += "</" + b.call(String(e.nodeName)) + ">", E;
    }
    if (P(e)) {
      if (e.length === 0)
        return "[]";
      var J = W(e, u);
      return h && !Zt(J) ? "[" + F(J, h) + "]" : "[ " + l.call(J, ", ") + " ]";
    }
    if (Ct(e)) {
      var U = W(e, u);
      return !("cause" in Error.prototype) && "cause" in e && !rt.call(e, "cause") ? "{ [" + String(e) + "] " + l.call(tt.call("[cause]: " + u(e.cause), U), ", ") + " }" : U.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + l.call(U, ", ") + " }";
    }
    if (typeof e == "object" && y) {
      if (ot && typeof e[ot] == "function" && B)
        return B(e, { depth: H - a });
      if (y !== "symbol" && typeof e.inspect == "function")
        return e.inspect();
    }
    if (Jt(e)) {
      var ht = [];
      return Y && Y.call(e, function(m, q) {
        ht.push(u(q, e, !0) + " => " + u(m, e));
      }), st("Map", $.call(e), ht, h);
    }
    if (Kt(e)) {
      var mt = [];
      return Z && Z.call(e, function(m) {
        mt.push(u(m, e));
      }), st("Set", I.call(e), mt, h);
    }
    if (Ut(e))
      return z("WeakMap");
    if (Qt(e))
      return z("WeakSet");
    if (Gt(e))
      return z("WeakRef");
    if (Pt(e))
      return _(u(Number(e)));
    if (Ft(e))
      return _(u(D.call(e)));
    if (zt(e))
      return _(Mt.call(e));
    if (Bt(e))
      return _(u(String(e)));
    if (typeof window < "u" && e === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && e === globalThis || typeof _t < "u" && e === _t)
      return "{ [object globalThis] }";
    if (!Nt(e) && !ft(e)) {
      var G = W(e, u), dt = nt ? nt(e) === Object.prototype : e instanceof Object || e.constructor === Object, K = e instanceof Object ? "" : "null prototype", Ot = !dt && w && Object(e) === e && w in e ? A.call(p(e), 8, -1) : K ? "Object" : "", bt = dt || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", Q = bt + (Ot || K ? "[" + l.call(tt.call([], Ot || [], K || []), ": ") + "] " : "");
      return G.length === 0 ? Q + "{}" : h ? Q + "{" + F(G, h) + "}" : Q + "{ " + l.call(G, ", ") + " }";
    }
    return String(e);
  };
  function lt(t, e, n) {
    var a = n.quoteStyle || e, i = ut[a];
    return i + t + i;
  }
  function Dt(t) {
    return c.call(String(t), /"/g, "&quot;");
  }
  function g(t) {
    return !w || !(typeof t == "object" && (w in t || typeof t[w] < "u"));
  }
  function P(t) {
    return p(t) === "[object Array]" && g(t);
  }
  function Nt(t) {
    return p(t) === "[object Date]" && g(t);
  }
  function ft(t) {
    return p(t) === "[object RegExp]" && g(t);
  }
  function Ct(t) {
    return p(t) === "[object Error]" && g(t);
  }
  function Bt(t) {
    return p(t) === "[object String]" && g(t);
  }
  function Pt(t) {
    return p(t) === "[object Number]" && g(t);
  }
  function zt(t) {
    return p(t) === "[object Boolean]" && g(t);
  }
  function ct(t) {
    if (S)
      return t && typeof t == "object" && t instanceof Symbol;
    if (typeof t == "symbol")
      return !0;
    if (!t || typeof t != "object" || !C)
      return !1;
    try {
      return C.call(t), !0;
    } catch {
    }
    return !1;
  }
  function Ft(t) {
    if (!t || typeof t != "object" || !D)
      return !1;
    try {
      return D.call(t), !0;
    } catch {
    }
    return !1;
  }
  var Ht = Object.prototype.hasOwnProperty || function(t) {
    return t in this;
  };
  function f(t, e) {
    return Ht.call(t, e);
  }
  function p(t) {
    return qt.call(t);
  }
  function Vt(t) {
    if (t.name)
      return t.name;
    var e = Tt.call(Rt.call(t), /^function\s*([\w$]+)/);
    return e ? e[1] : null;
  }
  function pt(t, e) {
    if (t.indexOf)
      return t.indexOf(e);
    for (var n = 0, a = t.length; n < a; n++)
      if (t[n] === e)
        return n;
    return -1;
  }
  function Jt(t) {
    if (!$ || !t || typeof t != "object")
      return !1;
    try {
      $.call(t);
      try {
        I.call(t);
      } catch {
        return !0;
      }
      return t instanceof Map;
    } catch {
    }
    return !1;
  }
  function Ut(t) {
    if (!d || !t || typeof t != "object")
      return !1;
    try {
      d.call(t, d);
      try {
        O.call(t, O);
      } catch {
        return !0;
      }
      return t instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Gt(t) {
    if (!x || !t || typeof t != "object")
      return !1;
    try {
      return x.call(t), !0;
    } catch {
    }
    return !1;
  }
  function Kt(t) {
    if (!I || !t || typeof t != "object")
      return !1;
    try {
      I.call(t);
      try {
        $.call(t);
      } catch {
        return !0;
      }
      return t instanceof Set;
    } catch {
    }
    return !1;
  }
  function Qt(t) {
    if (!O || !t || typeof t != "object")
      return !1;
    try {
      O.call(t, O);
      try {
        d.call(t, d);
      } catch {
        return !0;
      }
      return t instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Xt(t) {
    return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
  }
  function yt(t, e) {
    if (t.length > e.maxStringLength) {
      var n = t.length - e.maxStringLength, a = "... " + n + " more character" + (n > 1 ? "s" : "");
      return yt(A.call(t, 0, e.maxStringLength), e) + a;
    }
    var i = At[e.quoteStyle || "single"];
    i.lastIndex = 0;
    var r = c.call(c.call(t, i, "\\$1"), /[\x00-\x1f]/g, Yt);
    return lt(r, "single", e);
  }
  function Yt(t) {
    var e = t.charCodeAt(0), n = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[e];
    return n ? "\\" + n : "\\x" + (e < 16 ? "0" : "") + Lt.call(e.toString(16));
  }
  function _(t) {
    return "Object(" + t + ")";
  }
  function z(t) {
    return t + " { ? }";
  }
  function st(t, e, n, a) {
    var i = a ? F(n, a) : l.call(n, ", ");
    return t + " (" + e + ") {" + i + "}";
  }
  function Zt(t) {
    for (var e = 0; e < t.length; e++)
      if (pt(t[e], `
`) >= 0)
        return !1;
    return !0;
  }
  function xt(t, e) {
    var n;
    if (t.indent === "	")
      n = "	";
    else if (typeof t.indent == "number" && t.indent > 0)
      n = l.call(Array(t.indent + 1), " ");
    else
      return null;
    return {
      base: n,
      prev: l.call(Array(e + 1), n)
    };
  }
  function F(t, e) {
    if (t.length === 0)
      return "";
    var n = `
` + e.prev + e.base;
    return n + l.call(t, "," + n) + `
` + e.prev;
  }
  function W(t, e) {
    var n = P(t), a = [];
    if (n) {
      a.length = t.length;
      for (var i = 0; i < t.length; i++)
        a[i] = f(t, i) ? e(t[i], t) : "";
    }
    var r = typeof N == "function" ? N(t) : [], y;
    if (S) {
      y = {};
      for (var v = 0; v < r.length; v++)
        y["$" + r[v]] = r[v];
    }
    for (var o in t)
      f(t, o) && (n && String(Number(o)) === o && o < t.length || S && y["$" + o] instanceof Symbol || (j.call(/[^\w$]/, o) ? a.push(e(o, t) + ": " + e(t[o], t)) : a.push(o + ": " + e(t[o], t))));
    if (typeof N == "function")
      for (var s = 0; s < r.length; s++)
        rt.call(t, r[s]) && a.push("[" + e(r[s]) + "]: " + e(t[r[s]], t));
    return a;
  }
  return X;
}
export {
  ne as __require
};
//# sourceMappingURL=index.es104.js.map
